import { imgBaseURL, envNewH5BaseURL, envCapiOssURL, homeApiBaseURL, } from "../../build/config.js";

/**
 * 根据运行环境，返回对应的img域名全路径
 * @param {*} img path
 * @returns url
 */
function getImgSrc(img) {
  let url = 'https://cib-zhongtai.oss-cn-beijing.aliyuncs.com/'
  // if (img) {
  //   let url = `${imgBaseURL}/${img}`;
  //   return url;
  // } else {
  //   return "";
  // }
  if (!img) return "";
  if (img.includes("http:") || img.includes("https:")) return img;
  console.log(`${url}${img}`,"`${imgBaseURL}${img}`");
  return `${url}${img}`;
}

/**
 * 根据不同环境获取新版H5域名
 * @param {*} url path
 * @returns url
 */
function getNewH5Url(url) {
  return `${envNewH5BaseURL}${url}`;
}

/**
 * 根据不同环境获取中台的oss地址
 * @param {*} url path
 * @returns url
 */
function getCapiOssUrl(url) {
  return envCapiOssURL + url;
}

/**
 * 根据不同环境获取官网baseUrl + path
 * @param {*} url pathname
 * @returns url
 */
function getHomeApiBaseUrl (url) {
  return imgBaseURL + url;
}

export { getImgSrc, getNewH5Url, getCapiOssUrl, getHomeApiBaseUrl };



// WEBPACK FOOTER //
// ./src/utils/img.js